module.exports = __webpack_public_path__ + "img/check.964f53fe.svg";